// import Carousel from "react-material-ui-carousel";
// import { useEffect, useState, useMemo } from "react";
// import "./carousel.scss";
// import PopupModal from "./Modal/PopupModal";

// const Carousels = ({ data = [] }) => {
//   const [dynamicInterval, setDynamicInterval] = useState(5000);
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [isReady, setIsReady] = useState(false);
//   const [autoPlay, setAutoPlay] = useState(false);
//   const [loadedSlides, setLoadedSlides] = useState(new Set());

//   const [getPopUpShow, setPopUpShow] = useState(false);

//   const onhide = () => {
//     setPopUpShow(false);
//   };

//   const handelclick = () => {
//     setPopUpShow(true);
//   };

//   useEffect(() => {
//     if (data.length > 0) {
//       setDynamicInterval(data[0]?.interval || 5000);
//       const readyTimer = setTimeout(() => setIsReady(true), 100);
//       return () => clearTimeout(readyTimer);
//     }
//   }, [data]);

//   useEffect(() => {
//     if (isReady && data[activeIndex]) {
//       setDynamicInterval(data[activeIndex].interval || 5000);
//     }
//   }, [activeIndex, data, isReady]);

//   // ✅ Wait longer before autoplay starts (3.5 seconds)
//   useEffect(() => {
//     if (loadedSlides.has(0)) {
//       const autoPlayTimer = setTimeout(() => {
//         setAutoPlay(true);
//       }, 3500); // Increased from 2000
//       return () => clearTimeout(autoPlayTimer);
//     }
//   }, [loadedSlides]);

//   const slides = useMemo(() => data.filter(Boolean), [data]);

//   const handleImageLoad = (index) => {
//     setLoadedSlides((prev) => new Set([...prev, index]));
//   };

//   if (!isReady || slides.length === 0) {
//     return (
//       <div
//         className="carousel-skeleton"
//         style={{
//           width: "100%",
//           height: "600px",
//           backgroundColor: "#f0f0f0",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <Carousel
//         interval={dynamicInterval}
//         duration={1000} // ✅ Slower slide transition
//         indicators
//         navButtonsAlwaysInvisible
//         animation="slide"
//         autoPlay={autoPlay}
//         stopAutoPlayOnHover={true}
//         className="mb-5"
//         index={activeIndex}
//         onChange={(now) => setActiveIndex(now)}
//       >
//         {slides.map((item, index) => {
//           const isCurrentSlide = index === activeIndex;
//           const isLoaded = loadedSlides.has(index);

//           return (
//             <div key={item.id ?? index} className="carouel">
//               <img
//                 className="img-fluid carousel-img"
//                 src={item.cover}
//                 alt={item.title || `carousel slide ${index + 1}`}
//                 loading={index === 0 ? "eager" : "lazy"}
//                 onLoad={() => handleImageLoad(index)}
//                 onError={(e) => {
//                   e.target.src = "/assets/carousleImages/fallback.jpg";
//                   handleImageLoad(index);
//                 }}
//               />

//               <div
//                 className={`text-field ${isCurrentSlide && isLoaded ? "animate-in" : ""}`}
//               >
//                 <div className="row">
//                   {item.title && (
//                     <div className="col-12">
//                       <h2 className="carousel-title">{item.title}</h2>
//                     </div>
//                   )}

//                   {item.subtitle && (
//                     <div className="col-12">
//                       <h5 className="carousel-subtitle">{item.subtitle}</h5>
//                     </div>
//                   )}

//                   {item.desc && (
//                     <div className="col-12">
//                       <p className="carousel-desc">{item.desc}</p>
//                     </div>
//                   )}

//                   {item.buttonText && (
//                     <div className="col-12 mt-4 d-flex gap-3">
//                       {/* Get Started */}
//                       <button
//                         type="button"
//                         className="carousel-btn-filled"
//                         onClick={handelclick}
//                       >
//                         {item.buttonText}
//                       </button>

//                       {/* Learn More */}
//                       {item.learnMoreText && item.learnMoreLink && (
//                         <a
//                           href={item.learnMoreLink}
//                           className="carousel-btn-outline"
//                         >
//                           {item.learnMoreText}
//                         </a>
//                       )}
//                     </div>
//                   )}
//                   <PopupModal show={getPopUpShow} onHide={onhide} />
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </Carousel>
//     </>
//   );
// };

// export default Carousels;

import Carousel from "react-material-ui-carousel";
import { useEffect, useState, useMemo } from "react";
import "./carousel.scss";
import PopupModal from "./Modal/PopupModal";

const Carousels = ({ data = [] }) => {
  const [dynamicInterval, setDynamicInterval] = useState(5000);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isReady, setIsReady] = useState(false);
  const [autoPlay, setAutoPlay] = useState(false);
  const [loadedSlides, setLoadedSlides] = useState(new Set());
  const [getPopUpShow, setPopUpShow] = useState(false);

  const onhide = () => {
    setPopUpShow(false);
  };

  const handelclick = () => {
    setPopUpShow(true);
  };

  useEffect(() => {
    if (data.length > 0) {
      setDynamicInterval(data[0]?.interval || 5000);
      const readyTimer = setTimeout(() => setIsReady(true), 100);
      return () => clearTimeout(readyTimer);
    }
  }, [data]);

  useEffect(() => {
    if (isReady && data[activeIndex]) {
      setDynamicInterval(data[activeIndex].interval || 5000);
    }
  }, [activeIndex, data, isReady]);

  useEffect(() => {
    if (loadedSlides.has(0)) {
      const autoPlayTimer = setTimeout(() => {
        setAutoPlay(true);
      }, 3500);
      return () => clearTimeout(autoPlayTimer);
    }
  }, [loadedSlides]);

  const slides = useMemo(() => data.filter(Boolean), [data]);

  const handleImageLoad = (index) => {
    setLoadedSlides((prev) => new Set([...prev, index]));
  };

  if (!isReady || slides.length === 0) {
    return (
      <div
        className="carousel-skeleton"
        style={{
          width: "100%",
          height: "600px",
          backgroundColor: "#f0f0f0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <Carousel
        interval={dynamicInterval}
        duration={1000}
        indicators
        navButtonsAlwaysInvisible
        animation="slide"
        autoPlay={autoPlay}
        stopAutoPlayOnHover={true}
        className="mb-5"
        index={activeIndex}
        onChange={(now) => setActiveIndex(now)}
        swipe={true}
      >
        {slides.map((item, index) => {
          const isCurrentSlide = index === activeIndex;
          const isLoaded = loadedSlides.has(index);

          return (
            <div key={item.id ?? index} className="carouel">
              <img
                className="img-fluid carousel-img"
                src={item.cover}
                alt={item.title || `carousel slide ${index + 1}`}
                loading={index === 0 ? "eager" : "lazy"}
                onLoad={() => handleImageLoad(index)}
                onError={(e) => {
                  e.target.src = "/assets/carousleImages/fallback.jpg";
                  handleImageLoad(index);
                }}
              />

              <div
                className={`text-field ${isCurrentSlide && isLoaded ? "animate-in" : ""}`}
              >
                <div className="row">
                  {item.title && (
                    <div className="col-12">
                      <h2 className="carousel-title">{item.title}</h2>
                    </div>
                  )}

                  {item.subtitle && (
                    <div className="col-12">
                      <h5 className="carousel-subtitle">{item.subtitle}</h5>
                    </div>
                  )}

                  {item.desc && (
                    <div className="col-12">
                      <p className="carousel-desc">{item.desc}</p>
                    </div>
                  )}

                  {item.buttonText && (
                    <div className="col-12 mt-4 d-flex gap-3">
                      <button
                        type="button"
                        className="carousel-btn-filled carousel-btn"
                        onClick={handelclick}
                        aria-label={item.buttonText}
                      >
                        {item.buttonText}
                      </button>

                      {item.learnMoreText && item.learnMoreLink && (
                        <a
                          href={item.learnMoreLink}
                          className="carousel-btn-outline carousel-btn"
                          aria-label={item.learnMoreText}
                        >
                          {item.learnMoreText}
                        </a>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </Carousel>
      <PopupModal show={getPopUpShow} onHide={onhide} />
    </>
  );
};

export default Carousels;
